export default __webpack_public_path__ + "static/perform-popup-promo-c242246c55de82be3e6890ba85fe5937.svg";